
import {define} from "observable:runtime";
import asset1 from "../style.css?url";

const assets = new Map([
  ["../style.css", asset1]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle} = await import("../lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, canvasOutput, canvasTest, canvasTestReport } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,codeEditor,canvasOutput,canvasTest,canvasTestReport};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","codeEditor","canvasOutput","canvasTest","canvasTestReport"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const code_circle = view(codeEditor("canvas:shapes-circle", {
  value: `ctx.fillStyle = "red" // Man kann auch die Namen von Farben verwenden
ctx.strokeStyle = "green" // statt RGB-Werte
ctx.lineWidth = 40

ctx.beginPath()
ctx.arc(150, 150, 100, 0, 2 * Math.PI)
ctx.fill()    // erst füllen
ctx.stroke()  // dann den Rand`
}));
return {code_circle};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_circle"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: (display,canvasOutput,code_circle) => {
display(canvasOutput(code_circle, { width: 320, height: 320 }));
},
    inputs: ["display","canvasOutput","code_circle"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-8`),
    expanded: [],
    variables: []
  },
  {
    id: 8,
    body: (view,codeEditor) => {
const code_line1 = view(codeEditor("canvas:shapes-line1", {
  value: `ctx.beginPath()
ctx.moveTo(50, 50)     // Startpunkt
ctx.lineTo(200, 150)   // Endpunkt
ctx.stroke()`
}));
return {code_line1};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_line1"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: (display,canvasOutput,code_line1) => {
display(canvasOutput(code_line1, { width: 300, height: 220 }));
},
    inputs: ["display","canvasOutput","code_line1"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-11`),
    expanded: [],
    variables: []
  },
  {
    id: 11,
    body: (view,codeEditor) => {
const code_line2 = view(codeEditor("canvas:shapes-line2", {
  value: `ctx.beginPath()
ctx.moveTo(50, 50)
ctx.lineTo(250, 50)
ctx.lineTo(250, 250)
ctx.lineTo(50, 250)
ctx.stroke()`
}));
return {code_line2};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_line2"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-12`),
    expanded: [],
    variables: []
  },
  {
    id: 12,
    body: (display,canvasOutput,code_line2) => {
display(canvasOutput(code_line2, { width: 320, height: 320 }));
},
    inputs: ["display","canvasOutput","code_line2"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-14`),
    expanded: [],
    variables: []
  },
  {
    id: 14,
    body: (view,codeEditor) => {
const code_line3 = view(codeEditor("canvas:shapes-line3", {
  value: `ctx.beginPath()
ctx.moveTo(100, 50)    // Spitze oben
ctx.lineTo(50, 150)    // Ecke unten links
ctx.lineTo(150, 150)   // Ecke unten rechts
ctx.closePath()        // zurück zum Start
ctx.fill()`
}));
return {code_line3};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_line3"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-15`),
    expanded: [],
    variables: []
  },
  {
    id: 15,
    body: (display,canvasOutput,code_line3) => {
display(canvasOutput(code_line3, { width: 220, height: 220 }));
},
    inputs: ["display","canvasOutput","code_line3"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-17`),
    expanded: [],
    variables: []
  },
  {
    id: 17,
    body: (view,codeEditor) => {
const code_lw = view(codeEditor("canvas:shapes-linewidth", {
  value: `ctx.strokeStyle = "black"

for (const line of [[40, 1], [90, 5], [140, 15], [190, 25]]) {
  const y = line[0]
  const breite = line[1]
  ctx.lineWidth = breite
  ctx.beginPath()
  ctx.moveTo(50, y)
  ctx.lineTo(250, y)
  ctx.stroke()
}`
}));
return {code_lw};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_lw"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-18`),
    expanded: [],
    variables: []
  },
  {
    id: 18,
    body: (display,canvasOutput,code_lw) => {
display(canvasOutput(code_lw, { width: 300, height: 240 }));
},
    inputs: ["display","canvasOutput","code_lw"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-20`),
    expanded: [],
    variables: []
  },
  {
    id: 20,
    body: (display,canvasOutput) => {
display(canvasOutput(`const cx = 160
const cy = 210
ctx.lineWidth = 18

// [Farbe, Radius] — von außen nach innen
const baender = [["red", 130], ["orange", 112], ["yellow", 94], ["green", 76], ["blue", 58]]
for (const band of baender) {
  ctx.strokeStyle = band[0]
  const radius = band[1]
  ctx.beginPath()
  ctx.arc(cx, cy, radius, Math.PI, 2 * Math.PI)   // oberer Halbkreis
  ctx.stroke()
}`, { width: 320, height: 320 }));
},
    inputs: ["display","canvasOutput"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-21`),
    expanded: [],
    variables: []
  },
  {
    id: 21,
    body: (view,codeEditor) => {
const code_ex = view(codeEditor("canvas:shapes-pacman", {
  value: `// Zeichne einen Regenbogen:
`
}));
return {code_ex};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_ex"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-22`),
    expanded: [],
    variables: []
  },
  {
    id: 22,
    body: (display,canvasOutput,code_ex) => {
display(canvasOutput(code_ex, { width: 320, height: 320 }));
},
    inputs: ["display","canvasOutput","code_ex"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-23`),
    expanded: [],
    variables: []
  },
  {
    id: 23,
    body: (display,canvasTestReport,canvasTest,code_ex) => {
display(canvasTestReport(canvasTest(code_ex, {
  width: 320, height: 320,
  checks: [
    { name: "Mehrere bunte Bögen (rot, gelb, blau)", run: ({ base }) => {
        const farben = [[255, 0, 0], [255, 255, 0], [0, 0, 255]];
        const da = farben.filter(c => base.region(c, 40).count > 30).length;
        return { passed: da >= 3, detail: da >= 3 ? null : `nur ${da} von 3 erwarteten Farben (rot/gelb/blau) gefunden` };
    } },
    { name: "Bögen zentriert um x = 160", run: ({ base }) => {
        const r = base.region([255, 0, 0], 40);
        if (r.count < 30) return { passed: false, detail: "kein roter Bogen gefunden" };
        const ok = Math.abs(r.cx - 160) <= 40;
        return { passed: ok, detail: ok ? null : `Mittelpunkt der Bögen bei x ≈ ${Math.round(r.cx)} statt 160` };
    } },
    { name: "Nur oberer Halbkreis (Bögen öffnen nach unten)", run: ({ base }) => {
        const r = base.region([255, 0, 0], 40);
        if (r.count < 30) return { passed: false, detail: "kein roter Bogen gefunden" };
        const ok = r.cy < 195;
        return { passed: ok, detail: ok ? null : `Bögen liegen nicht im oberen Halbkreis (Schwerpunkt y ≈ ${Math.round(r.cy)})` };
    } },
    { name: "Hohle Mitte (Bögen statt gefüllter Fläche)", run: ({ base }) =>
        base.isBackground(160, 180, 20) || { passed: false, detail: "die Mitte ist gefüllt — zeichne nur Bögen mit stroke(), nicht fill()" }
    }
  ]
}), "Übung"));
},
    inputs: ["display","canvasTestReport","canvasTest","code_ex"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
